import { render, staticRenderFns } from "./searchPrip.vue?vue&type=template&id=483fb40d&scoped=true"
import script from "./searchPrip.vue?vue&type=script&lang=js"
export * from "./searchPrip.vue?vue&type=script&lang=js"
import style0 from "./searchPrip.vue?vue&type=style&index=0&id=483fb40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483fb40d",
  null
  
)

export default component.exports